<script>
	import {replace} from "svelte-spa-router";
	import Controlador from "../controlador.svelte";
	import {onMount,beforeUpdate} from "svelte";
	import {docs,logueo} from "../store.js";
	import ItemEmpleado from "../componentes/itemEmpleado.svelte";
	let c;
	let filtro = "";
	let lista = [
		{id:"empleado:Melina Di Modica",puesto:"Encargada", nombre:"Melina Di Modica",telefono:"+541123123",historial:[]}
	]
	onMount(()=>{
		lista = $docs.filter((el)=>el._id.includes("empleado:"));
		if (!$logueo){
			replace('/');
		}
	})
	beforeUpdate(()=>{
		if (lista){
			lista = $docs.filter((el)=>el._id.includes("empleado:")).filter((el)=>{
				return (el.nombre.toLowerCase().includes(filtro.toLowerCase()) || el.apellido.toLowerCase().includes(filtro.toLowerCase()) || el.sobrenombre.toLowerCase().includes(filtro.toLowerCase()) );
			})
		}
	})
</script>
<Controlador bind:this={c} />
<div class="p-4 w-full sm:w-3/4 m-2 flex flex-col items-center">
	<div class="w-full flex items-center">
		<a href="#/home" class="w-full bg-red-500 text-white flex m-2 p-2 rounded shadow cursor-pointer hover:bg-red-300 hover:shadow-2">
			<i class="ri-arrow-left-line" />
			Volver
		</a>
		<a href="#/empleados/nuevo" class="w-full bg-red-500 text-white flex m-2 p-2 rounded shadow cursor-pointer hover:bg-red-300 hover:shadow-2">
			<i class="ri-add-line" />
			Agregar Empleado
		</a>
	</div>
	<input bind:value={filtro} type="text" placeholder="Filtro" class="w-full m-2 p-2 rounded shadow" />
	{#each lista as e}
		<ItemEmpleado empleado={e} />
	{/each}
</div>
